import React from 'react';
import { Grid, Typography } from '@mui/material';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { observer } from 'mobx-react';
import { LevelStore } from '@gamiphy/loyalty-station-desktop/store/level';
import { DisplayStringTrans, useTranslation } from '@gamiphy/react-i18n';
import { TierConfigType } from '@gamiphy/bl/level';

const UserPoints: React.FC = observer(() => {
  const { user } = UserStore;
  const { t } = useTranslation();
  if (!user) return null;
  return (
    <Grid
      container
      alignItems="center"
      spacing={1}
      wrap="nowrap"
      sx={{
        marginBottom: (theme) => theme.spacing(1),
        fontSize: '1.1rem',
      }}
    >
      <Grid>
        <img
          style={{
            display: 'flex',
            maxHeight: '1.5rem',
            position: 'relative',
            zIndex: 9,
          }}
          src={LevelStore.currentTier?.icon}
          alt={LevelStore.currentTier?.key}
        />
      </Grid>
      <Grid>
        <Typography
          component="span"
          sx={{
            fontWeight: 500,
            color: (theme) => theme.palette.text.secondary,
          }}
        >
          <DisplayStringTrans displayString={LevelStore.currentTier?.name} />
        </Typography>
        {(LevelStore.tierConfig?.type === TierConfigType.exp || LevelStore.tierConfig?.type === TierConfigType.gainedPoints) && (
          <Typography
            component="span"
            sx={{
              fontSize: '1.2rem',
              fontWeight: 'bold',
              marginLeft: (theme) => theme.spacing(0.2),
              color: (theme) => theme.palette.text.secondary,
            }}
          >
            {` ${String.fromCharCode(8226)} `}
          </Typography>
        )}
      </Grid>
      {
        (LevelStore.tierConfig?.type === TierConfigType.exp || LevelStore.tierConfig?.type === TierConfigType.gainedPoints) && (
          <Grid sx={{
            zIndex: 22,
            fontWeight: 500,
            color: (theme) => theme.palette.text.secondary,
          }}
          >
            <Typography component="span">
              {`${LevelStore.accumulated}${LevelStore.nextTier ? `/${LevelStore.nextTier.neededAmount}` : ''}`}
            </Typography>
            {' '}
            <Typography component="span">
              {LevelStore.tierConfig?.type === TierConfigType.exp ? (t('shard.exp', 'Exp')) : (t('shared.points', 'points'))}
            </Typography>
          </Grid>
        )
      }
    </Grid>
  );
});

export default UserPoints;
